import { FC } from "react";

import TopNav from "../../components/TopNav/TopNav";
import ContentLayout from "../ContentLayout/ContentLayout";
import { SettingLayoutProps } from "./types";

import styles from "./SettingLayout.module.css";



const SettingLayout: FC<SettingLayoutProps> = ({ children, title = "Profile Settings" }) => {
  return (
    <div className={styles["setting-layout"]}>
      <TopNav title={title} />
      <ContentLayout>{children}</ContentLayout>
    </div>
  );
};

export default SettingLayout;
